'use client';

import type { ReactNode } from 'react';
import { cn } from '../_lib/utils';
import { Button } from '../Inputs/Button';
import { isValidRichText } from '../_lib/isValidRichText';
import ThumbsDownIcon from '../_assets/icons/thumbsDownFilled.svg';
import ThumbsUpIcon from '../_assets/icons/thumbsUpFilled.svg';
import { Text } from '../Text';

export type FeedbackCardProps = {
	copy?: ReactNode;
	className?: string;
	like?: string;
	dislike?: string;
};

export function FeedbackCard(props: FeedbackCardProps) {
	return (
		<article className={`container-xl w-full`} data-component='FeedbackCard'>
			<div
				className={cn(
					'group relative p-8 sm:pl-10 rounded-[1.25rem] flex flex-col gap-4 items-center justify-between sm:flex-row bg-background-secondary/10',
					props.className,
				)}
			>
				{isValidRichText(props.copy) && <Text styleType='heading-3xs'>{props.copy}</Text>}
				<div className='flex flex-row'>
					<Button parent='FeedbackCard' iconLeft={<ThumbsUpIcon />} styleType='ghost'>
						{props.like && <>{props.like}</>}
					</Button>
					<Button parent='FeedbackCard' iconLeft={<ThumbsDownIcon />} styleType='ghost'>
						{props.dislike && <>{props.dislike}</>}
					</Button>
				</div>
			</div>
		</article>
	);
}
